import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'cc-empty-table-message',
  templateUrl: './empty-table-message.component.html',
  styleUrls: ['./empty-table-message.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class EmptyTableMessageComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
